export const FIRST_LOBBY_TUTORIAL_MODE = "free";
export const FIRST_LOBBY_TUTORIAL_ORDER = 22;
export const FIRST_LOBBY_TUTORIAL_LEVEL = 1;
export const SECOND_TUTORIAL_MODE = "cienzar";
export const SECOND_TUTORIAL_ORDER = 21;
export const SECOND_TUTORIAL_LEVEL = 2;

export const normalizeGuidedTutorialLevel = (rawLevel) => {
  const level = Number(rawLevel);
  return level === FIRST_LOBBY_TUTORIAL_LEVEL || level === SECOND_TUTORIAL_LEVEL
    ? level
    : 0;
};

export const buildPuzzleTutorialLaunchOptions = (rawLevel) => {
  const tutorialLevel = normalizeGuidedTutorialLevel(rawLevel);
  return {
    tutorialQuery: tutorialLevel > 0 ? `&tutorialLevel=${tutorialLevel}` : "",
    tutorialState: tutorialLevel > 0 ? { tutorialLevel } : undefined,
  };
};

const buildTutorialTarget = ({ mode, order, level, source }, requestNonce = Date.now()) => {
  const requestKey = `${source}-${requestNonce}`;
  const params = new URLSearchParams({
    quickView: "puzzles",
    puzzleMode: mode,
    openPuzzleMode: mode,
    openPuzzleOrder: String(order),
    tutorialLevel: String(level),
    openPuzzleRequestKey: requestKey,
    fromLobbySource: source,
  });

  return {
    pathname: `/game?${params.toString()}`,
    state: {
      source,
      fromLobbySource: source,
      openMatchmakingQuickView: "puzzles",
      openMatchmakingQuickViewRequestKey: requestKey,
      puzzleMode: mode,
      openPuzzleMode: mode,
      openPuzzleOrder: order,
      openPuzzleRequestKey: requestKey,
      tutorialLevel: level,
    },
  };
};

export const buildFirstLobbyTutorialTarget = (requestNonce = Date.now()) => {
  const target = buildTutorialTarget(
    {
      mode: FIRST_LOBBY_TUTORIAL_MODE,
      order: FIRST_LOBBY_TUTORIAL_ORDER,
      level: FIRST_LOBBY_TUTORIAL_LEVEL,
      source: "first-tutorial",
    },
    requestNonce
  );
  return {
    ...target,
    state: { ...target.state, source: "firstLobbyTutorial" },
  };
};

export const buildTutorialLevel2Target = (requestNonce = Date.now()) =>
  buildTutorialTarget(
    {
      mode: SECOND_TUTORIAL_MODE,
      order: SECOND_TUTORIAL_ORDER,
      level: SECOND_TUTORIAL_LEVEL,
      source: "tutorial-level-2",
    },
    requestNonce
  );
